export const REACT_APP_BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || 'https://his2.api.supergitsa.com/api').trim()

export const REACT_APP_BACKEND_URL_TEST = (process.env.REACT_APP_BACKEND_URL_TEST || 'https://his2.api.supergitsa.com/api').trim()

export const CurrentVersion = process.env.REACT_APP_CURRENT_VERSION
export const isDevelopment = process.env.NODE_ENV === 'development'
export const isProduction = process.env.NODE_ENV === 'production'
export const API_URL = isDevelopment ? REACT_APP_BACKEND_URL_TEST : REACT_APP_BACKEND_URL
